import React from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";

import { RealEstateWorkspaceShell } from "@features/real-estate/components/workspace-shell";
import { hasActiveWorkspace, RealEstateWorkspaceProvider, useRealEstateWorkspace } from "@features/real-estate/state/workspace";

import "@features/real-estate/index.scss";

const GuardedWorkspace = (): React.ReactElement => {
  const { state, dispatch } = useRealEstateWorkspace();
  const location = useLocation();
  const navigate = useNavigate();

  React.useEffect(() => {
    if (location.pathname === "/real-estate/intake") {
      return;
    }
    if (hasActiveWorkspace(state)) {
      return;
    }
    dispatch({ type: "set_redirect_notice", notice: "Start a new analysis to continue." });
    navigate("/real-estate/intake", { replace: true });
  }, [dispatch, location.pathname, navigate, state]);

  return (
    <RealEstateWorkspaceShell
      title="Real Estate ROI Lab"
      description="Public-source context and browser-only underwriting for long-term rental deals."
      enrichmentState={state.enrichmentState}
    >
      <Outlet />
    </RealEstateWorkspaceShell>
  );
};

export default function RealEstateWorkspaceView(): React.ReactElement {
  return (
    <RealEstateWorkspaceProvider>
      <GuardedWorkspace />
    </RealEstateWorkspaceProvider>
  );
}
